<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent>
      <v-btn class="success--text text-xs-right" flat slot="activator">file</v-btn>
      <v-card>
          <form class="ui form">
            <div class="form-group">
              <label for="exampleInputFile">File input</label>
              <input type="file" class="form-control-file" name="file" id="file" @change="addFile">
            </div>
          </form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red--text darken-1" flat @click.native="dialog = false">Cancel</v-btn>
          <v-btn class="success--text" flat @click.prevent="sendFile">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-layout>
</template>

<script>
import mime from 'mime-types'

export default {
  name: 'file-modal',
  data () {
    return {
      file: null,
      authorized: ['image/jpeg', 'image/png'],
      dialog: false
    }
  },
  methods: {
    addFile (e) {
      let files = e.target.files
      console.log(files)
      if (files.length === 1) {
        this.file = files[0]
      }
    },
    sendFile () {
      if (this.file !== null) {
        if (this.isValid(this.file.name)) {
          let metadata = { contentType: mime.lookup(this.file.name) }
          this.$parent.uploadFile(this.file, metadata)
        }
      }
    },
    isValid (filename) {
      let index = this.authorized.indexOf(mime.lookup(filename))
      return index !== -1
    },
    resetForm () {
      console.log('reset form')

      this.file = null
    }
  }
}

</script>



// WEBPACK FOOTER //
// FileModal.vue?460e43ca